import { useInfiniteQuery } from "@tanstack/react-query";
import type {
  RetailerMatchedListParametersType,
  RetailerMatchedListResponseType,
} from "@sellar-io/api-v2/types";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import {
  apiV2AssertResponse,
  ApiV2InfiniteQueryOptions,
  apiV2Request,
  getDefaultInfiniteQueryOptions,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useMatchedBuyersList = <TData = RetailerMatchedListResponseType,>(
  params: RetailerMatchedListParametersType,
  options?: ApiV2InfiniteQueryOptions<TData>,
) => {
  const { user } = useFirebaseUser();
  return useInfiniteQuery({
    queryKey: [user?.uid, ServerStateKeys.Retailers, params],
    queryFn: (queryParams) =>
      apiV2Request({
        user,
        business: null,
        method: "get",
        path: `retailers/matched-retailers`,
        params: {
          ...params,
          offset: queryParams.pageParam,
        },
      }).then((response) => apiV2AssertResponse<TData>(response).data),
    ...getDefaultInfiniteQueryOptions({ ...options, limit: params.limit }),
  });
};
